import jsonServerProvider from 'ra-data-json-server'
import { fetchUtils } from 'react-admin'
import { API_URL } from './consts';

let providerAddress = API_URL;

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' })
    }
    let token
    try {
        const auth = JSON.parse(localStorage.getItem('auth'))
        token = auth && auth.token
    } catch (error) {
        token = null
    }
    if (!token) {
        return Promise.reject({ status: 401, message: 'No auth token' })
    }
    options.headers.set('Authorization', `Bearer ${token}`)
    return fetchUtils.fetchJson(url, options)
}

const dataProvider = jsonServerProvider(providerAddress, httpClient)

const myDataProvider = {
    ...dataProvider,
    getList: (resource, params) => {
        return dataProvider.getList(resource, params).then((result) => {
            if (!Array.isArray(result.data)) {
                const raw = result.data
                const data = raw.data || raw.rows || raw.items || raw[resource.split('/').pop()] || []
                const total = raw.total || raw.count || data.length
                return { data, total }
            }
            return result
        })
    },
    getOne: (resource, params) => {
        return dataProvider.getOne(resource, params).then((result) => {
            if (result.data && result.data.id == null) {
                const inner = result.data.data || result.data
                return { data: inner }
            }
            return result
        })
    },
    update: (resource, params) => {
        if (!params.data.image) {
            return dataProvider.update(resource, params).then((result) => {
                if (result.data && result.data.id == null) {
                    const inner = result.data.data || { ...params.data, id: params.id }
                    return { data: inner }
                }
                return result
            })
        }

        let pictures = [params.data.image]
        if (Array.isArray(pictures[0])) pictures = pictures[0]

        const newPictures = pictures.filter((p) => p.rawFile instanceof File)
        const formerPictures = pictures.filter((p) => !(p.rawFile instanceof File))

        return Promise.all(newPictures.map(convertFileToBase64))
            .then((base64Pictures) =>
                base64Pictures.map((picture64) => ({
                    src: picture64.src,
                    title: picture64.title,
                }))
            )
            .then((transformedNewPictures) =>
                dataProvider.update(resource, {
                    ...params,
                    data: {
                        ...params.data,
                        pictures: [...transformedNewPictures, ...formerPictures],
                    },
                })
            )
            .then((result) => {
                if (result.data && result.data.id == null) {
                    const inner = result.data.data || { ...params.data, id: params.id }
                    return { data: inner }
                }
                return result
            })
    },
    create: (resource, params) => {
        if (!params.data.image) {
            return dataProvider.create(resource, params).then((result) => {
                if (result.data && result.data.id == null) {
                    const inner = result.data.data || result.data
                    return { data: inner }
                }
                return result
            })
        }

        const pictures = [params.data.image]
        const newPictures = pictures.filter(
            p => p.rawFile instanceof File
        )
        const formerPictures = pictures.filter(
            p => !(p.rawFile instanceof File)
        )

        return Promise.all(newPictures.map(convertFileToBase64))
            .then(base64Pictures =>
                base64Pictures.map(picture64 => ({
                    src: picture64.src,
                    title: picture64.title,
                }))
            )
            .then(transformedNewPictures =>
                dataProvider.create(resource, {
                    ...params,
                    data: {
                        ...params.data,
                        pictures: [
                            ...transformedNewPictures,
                            ...formerPictures,
                        ],
                    },
                })
            )
    },
}

const convertFileToBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve({ src: reader.result, title: file.title })
        reader.onerror = reject

        reader.readAsDataURL(file.rawFile)
    })

export default myDataProvider
